import { jsx as _jsx } from "react/jsx-runtime";
import Modal from "react-modal";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { closeOrderSummary } from "../../redux/reducers/modals";
import styles from "./custom-modal-container.module.scss";
import OrderSummary from "./orderSummary/orderSummary";
const CustomModalContainer = () => {
    const orderSummaryData = useAppSelector((state) => {
        return state.modals.orderSummaryData;
    });
    const orderSummaryLoading = useAppSelector((state) => {
        return state.modals.isOrderSummaryLoading;
    });
    const dispatch = useAppDispatch();
    return (_jsx("div", { children: _jsx(Modal, Object.assign({ isOpen: orderSummaryData || orderSummaryLoading ? true : false, onRequestClose: () => {
                dispatch(closeOrderSummary());
            }, className: `${styles.myCommonModal} ${styles.orderSummaryModal}`, overlayClassName: `${styles.myCommonOverlay}` }, { children: _jsx(OrderSummary, { orderSummaryData: orderSummaryData ? orderSummaryData : { orderResponseData: [] } }) })) }));
};
export default CustomModalContainer;
